"use client";

import { useEffect } from "react";

interface ILocaleLangSetterProps {
  locale: string;
}

export default function LocaleLangSetter({ locale }: ILocaleLangSetterProps) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);
  return null;
}
